export const version = '2.3.1';
export const navbarBreakPoint = 'xl';
